import { apiGet, apiPost } from '@/shared/utils/requestBuilder';
import type { Nomeacao } from '@/types/arbitral/nomeacaoTypes';

export const arbitroNomeacoesService = {
  listar: async (): Promise<Nomeacao[]> => {
    const response = await apiGet('/arbitral/nomeacoes');
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao listar nomeações' }));
      throw new Error(errorData.error || 'Erro ao listar nomeações');
    }
    const result = await response.json();
    return result.data.items;
  },

  aceitar: async (id: string): Promise<Nomeacao> => {
    const response = await apiPost(`/arbitral/nomeacoes/${id}/aceite`, {});
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao aceitar nomeação' }));
      throw new Error(errorData.error || 'Erro ao aceitar nomeação');
    }
    const result = await response.json();
    return result.data;
  },

  recusar: async (id: string, motivo: string): Promise<Nomeacao> => {
    const response = await apiPost(`/arbitral/nomeacoes/${id}/recusa`, { motivo });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Erro ao recusar nomeação' }));
      throw new Error(errorData.error || 'Erro ao recusar nomeação');
    }
    const result = await response.json();
    return result.data;
  },
};
